import PluginConfiguration from "./PluginConfiguration";
import PluginItemView from "./PluginItemView";

export default {
    pluginTypeId: 'htmlTemplate',
    pluginTypeName: 'HTML Template',
    PluginConfiguration: PluginConfiguration,
    PluginItemView: PluginItemView
}



// WEBPACK FOOTER //
// ./src/components/plugins/htmlTemplatePlugin/index.js